"use client";

import { useCartStore } from "@/providers/cart-store-provider"; // Update path based on your project
import { CartItem } from "@/stores/cart-store";
import React from "react";

import { ArrowRightIcon } from "lucide-react";
import Link from "next/link";
import { Button, buttonVariants } from "./ui/button";

export const AddToCartButton = ({
  product,
  disabled,
  children,
}: {
  product: Omit<CartItem, "quantity">;
  disabled?: boolean;
  children?: React.ReactNode;
}) => {
  const addToCart = useCartStore((state) => state.addToCart);
  const cartItem = useCartStore((state) =>
    state.items.find((item) => item.databaseId === product.databaseId)
  );

  return cartItem ? (
    <div className="flex items-center gap-2">
      <QtyButtons
        databaseId={cartItem.databaseId}
        quantity={cartItem.quantity}
        available_quantity={product.available_quantity}
      />
      <Link
        className={
          `w-full h-[48px] sm:h-auto sm:w-auto ` +
          buttonVariants({ variant: "default" })
        }
        href="/kassan"
      >
        Gå till kassan
      </Link>
    </div>
  ) : (
    // Render "Add to Cart" button if the product is not in the cart
    <div className="flex items-center">
      <Button
        className="w-full sm:w-auto h-[48px] sm:h-auto"
        effect="expandIcon"
        icon={ArrowRightIcon}
        iconPlacement="right"
        disabled={
          (product.available_quantity !== undefined &&
            product.available_quantity <= 0) ||
          disabled
        }
        onClick={() =>
          addToCart({
            ...product,
            quantity: 1,
          })
        }
      >
        {children}
      </Button>
    </div>
  );
};

const QtyButtons = ({
  databaseId,
  quantity,
  available_quantity,
}: {
  databaseId: number;
  quantity: number;
  available_quantity?: number;
}) => {
  const incrementQuantity = useCartStore((state) => state.incrementQuantity);
  const decrementQuantity = useCartStore((state) => state.decrementQuantity);
  return (
    <div className="flex items-center">
      <Button
        variant={"outline"}
        className="rounded-r-none h-[48px] sm:h-auto w-[48px] sm:w-auto"
        onClick={() => decrementQuantity(databaseId, 1)}
      >
        -
      </Button>
      <span className="text-[1rem] size-9 border-t border-b flex justify-center items-center h-[44px] sm:h-[35px] w-[44px] sm:w-[35px]">
        {quantity}
      </span>
      <Button
        variant={"outline"}
        className="rounded-l-none h-[48px] sm:h-auto w-[48px] sm:w-auto"
        disabled={
          available_quantity !== undefined && quantity >= available_quantity
        }
        onClick={() => incrementQuantity(databaseId, 1)}
      >
        +
      </Button>
    </div>
  );
};
